/* Pixel-art kiwi bird icon (Variant 28 from deprecated app). Uses currentColor for theming. */

interface KiwiIconProps {
  className?: string;
}

export function KiwiIcon({ className }: KiwiIconProps) {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Body */}
      <path
        d="M12 6H20V8H24V10H26V18H24V22H20V24H12V22H8V18H6V10H8V8H12V6Z"
        fill="currentColor"
      />
      {/* Highlight pixels */}
      <rect x="20" y="10" width="2" height="2" fill="currentColor" opacity="0.3" />
      <rect x="22" y="12" width="2" height="2" fill="currentColor" opacity="0.2" />
      {/* Beak */}
      <path
        d="M4 12H6V14H4V12ZM2 14H4V16H2V14ZM2 16H4V18H2V16ZM4 18H6V20H4V18Z"
        fill="currentColor"
      />
      {/* Tuft feathers */}
      <path
        d="M10 4H12V6H10V4ZM8 2H10V4H8V2ZM12 2H14V4H12V2Z"
        fill="currentColor"
      />
      {/* Eye */}
      <rect x="10" y="10" width="6" height="6" className="fill-background" />
      <rect x="12" y="12" width="2" height="2" fill="currentColor" />
      {/* Feet */}
      <path d="M12 24H14V28H12V24ZM10 28H16V30H10V28Z" fill="currentColor" />
      <path d="M18 24H20V28H18V24ZM16 28H22V30H16V28Z" fill="currentColor" />
    </svg>
  );
}
